export default __webpack_public_path__ + "static/gradient-wave-mobile-f8155e83639af7bee115a1384332b7d7.svg";